import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "@/components/collection/overview/utils"
import { FreeformContentBlockSlideFragment } from "../FreeformContentBlockSlide/FreeformContentBlockSlide.fragment"

export const FreeformContentCarouselFragment = graphql(
  `
    fragment FreeformContentCarousel on CollectionContentBlockModule {
      sections {
        __typename
        ... on DefaultContentBlock {
          title
          description
          blockMedia: media {
            ...MediaProps
          }
          externalLink {
            href
            label
          }
          ...FreeformContentBlockSlide
        }
      }
    }
  `,
  [FreeformContentBlockSlideFragment, getMediaPropsFromMediaFragment],
)
